export { default as debounce } from 'lodash/fp/debounce'
export { default as throttle } from 'lodash/fp/throttle'
